<script setup lang="ts">
interface Props {
  icon?: string
  disabled?: boolean
  tooltip?: unknown
}

const props = withDefaults(defineProps<Props>(), {
  icon: 'fa-light fa-plus fa-fw',
  disabled: false,
  tooltip: undefined
});

</script>

<template>
  <IonFab
    slot="fixed"
    vertical="bottom"
    horizontal="end"
  >
    <IonFabButton
      id="action"
      v-tooltip.left="props.tooltip"
      color="gradient"
      :disabled="props.disabled"
    >
      <i :class="props.icon" />
    </IonFabButton>
  </IonFab>
</template>

<style scoped>

i {
  font-size: 1.5rem;
}

ion-fab {
  bottom: 1.7em;
  right: 1.1em;
}
</style>
